import { CONFERENCE_JOINED, SET_ROOM } from '../../../react/features/base/conference/actionTypes';
import { updateFlags } from '../../../react/features/base/flags/actions';
import { RAISE_HAND_ENABLED, REACTIONS_ENABLED } from '../../../react/features/base/flags/constants';
import { raiseHand } from '../../../react/features/base/participants/actions';
import { PARTICIPANT_ROLE } from '../../../react/features/base/participants/constants';
import { getLocalParticipant, isParticipantModerator } from '../../../react/features/base/participants/functions';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
import { iAmVisitor } from '../../../react/features/visitors/functions';
import { sendMetaWebinarConfig } from './actions.any';
import { isMetaWebinarWasSend, isRaiseHandAllowed, isUserByIdSpeaker, isWebinarEnabledInRoom } from './functions';
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case SET_ROOM: {
            const { dispatch, getState } = store;
            if (!isRaiseHandAllowed(getState())) {
                dispatch(updateFlags({
                    [RAISE_HAND_ENABLED]: false,
                    [REACTIONS_ENABLED]: false
                }));
            }
            break;
        }
        case CONFERENCE_JOINED: {
            const { getState } = store;
            const state = getState();
            // @ts-ignore
            const { isXbees } = state['features/base/config'];
            const { visitorMute } = state['wildix/customStorageSettings'];
            if (!isWebinarEnabledInRoom(state) || !isXbees || visitorMute) {
                break;
            }
            return _conferenceJoined(store, action, next);
        }
    }
    return next(action);
});
function _conferenceJoined({ dispatch, getState }, action, next) {
    const result = next(action);
    const { conference } = action;
    if (conference) {
        const state = getState();
        if (iAmVisitor(state)) {
            if (!isRaiseHandAllowed(state)) {
                dispatch(showNotification({
                    titleKey: 'webinar.notification.title',
                    descriptionKey: 'webinar.notification.description'
                }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
            }
            if (isUserByIdSpeaker(state)) {
                dispatch(raiseHand(true));
            }
        }
        else {
            const participant = getLocalParticipant(state);
            if (!isMetaWebinarWasSend(state)) {
                const isModerator = isParticipantModerator(participant);
                if (!isModerator && conference.room) {
                    conference.room.role = PARTICIPANT_ROLE.MODERATOR;
                }
                dispatch(sendMetaWebinarConfig(conference));
            }
        }
    }
    return result;
}
